import React, { useReducer, useContext } from 'react';
import PropTypes from 'prop-types';

// Reducers
import AppReducer from './AppReducer';
import { getStoredUser, isUserAuthenticated } from '../utils/cognitoAuth';

const AppStateContext = React.createContext(null);
const AppDispatchContext = React.createContext(null);

const connectedUser = getStoredUser();

/**
 * @typedef Store
 * @property {Boolean} isAuthenticated
 * @property {import('../services/types').Resource} user
 */
const initStore = {
  isAuthenticated: isUserAuthenticated(),
  user: connectedUser,
};

function AppProvider({ children }) {
  const [state, dispatch] = useReducer(AppReducer, initStore);

  // useEffect(() => {
  //   //   if you want a persistant context in localstorage, add it here
  // }, [state]);

  return (
    <AppStateContext.Provider value={state}>
      <AppDispatchContext.Provider value={dispatch}>
        {children}
      </AppDispatchContext.Provider>
    </AppStateContext.Provider>
  );
}

AppProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

/**
 * Custom hook for accessing the global application context and dispatch function.
 *
 * This hook simplifies the process of accessing the global state and dispatch function
 * from the application's context. It returns an array containing the current state
 * and the dispatch function, allowing components to read from the global state and
 * dispatch actions to modify it.
 *
 *
 * @returns {[Store, Function]} An array where the first element is the current application
 * state object and the second element is the dispatch function to update the state.
 */
const useAppContext = () => [useContext(AppStateContext), useContext(AppDispatchContext)];

export {
  AppProvider,
  AppStateContext,
  AppDispatchContext,
  useAppContext,
};
